import { useState } from 'react'
import ArithmeticalEvaluation from './ArithmeticalEvaluation'
import TitleEvaluations from './TitleEvaluations'
import TrivalentEvaluation from './TrivalentEvaluation'
import { MdInfo } from "react-icons/md";
import { IArithmeticalEvaluation } from '../../interfaces/Rights';
import Dialog from '../Dialog/Dialog';

interface EvaluationInfoDialogProps { 
    isOpen: boolean;
    toggle: () => void;
    title: string;
    description: string;
}

const EvaluationInfoDialog = ({ isOpen, toggle, title, description }: EvaluationInfoDialogProps) => (
    <Dialog isOpen={isOpen} toggle={toggle} bgColor='bg-brand-green-5' >
        <div className="flex justify-center mb-2">
            <MdInfo size={32} color="#205253" />
        </div>
        <h2 className="text-center text-hsmall text-system-light-100 mb-4">{title}</h2>
        <p className="text-left text-bmedium text-system-light-100">{description}</p>
    </Dialog>
);

interface IEvaluations {
    arithmeticalEvaluation: IArithmeticalEvaluation[]
    showArithmeticalIndicators: boolean
    arithmeticalEvaluationLabel: string
    trivalentEvaluation: number | null
    trivalentStateStyle: string
    evaluationStyle: string
    backgroundColorCard: string
    showTitleEvaluation: boolean
    labelArithmeticalEvaluationStyle: string
}

/**
 * Component showing trivalent and arithmetical evaluation
 */
const Evaluations = ({
    arithmeticalEvaluation,
    showArithmeticalIndicators,
    arithmeticalEvaluationLabel,
    trivalentEvaluation,
    trivalentStateStyle,
    evaluationStyle,
    backgroundColorCard,
    showTitleEvaluation,
    labelArithmeticalEvaluationStyle
}: IEvaluations) => {

    const [isModalVisibleArith, setIsModalVisibleArith] = useState(false);
    const [isModalVisibleTri, setIsModalVisibleTri] = useState(false);

    return (
        <div className='relative'>
            <div className='flex flex-col sm:flex-row gap-3 md:gap-6 w-full h-full'>
                <div className='flex flex-col w-full gap-3 relative'>
                    {
                        showTitleEvaluation
                        && <TitleEvaluations
                            label='Evaluación aritmética'
                            onClick={() => setIsModalVisibleArith(!isModalVisibleArith)}
                        />
                    }
                    <ArithmeticalEvaluation
                        data={arithmeticalEvaluation}
                        showIndicators={showArithmeticalIndicators}
                        label={arithmeticalEvaluationLabel}
                        backgroundColor={backgroundColorCard}
                        classNameLabel={labelArithmeticalEvaluationStyle}
                    />
                </div>
                <div className='flex flex-col w-full gap-3  relative'>
                    {
                        showTitleEvaluation
                        && <TitleEvaluations
                            label='Evaluación trivalente'
                            onClick={() => setIsModalVisibleTri(!isModalVisibleTri)}
                        />
                    }
                    <TrivalentEvaluation
                        evaluationRight={trivalentEvaluation}
                        stateStyleText={trivalentStateStyle}
                        evaluationStateStyleText={evaluationStyle}
                        bgColor={backgroundColorCard}
                    />
                </div>
            </div>
            <EvaluationInfoDialog
                isOpen={isModalVisibleArith}
                toggle={() => setIsModalVisibleArith(false)}
                title="Evaluación aritmética"
                description="Con esta barra te mostramos – en verde, rojo o amarillo – la cantidad total de los indicadores que en términos individuales registraron mejoras, retrocesos o se mantuvieron iguales. Como se trata de información desagregada, puede no coincidir con el estado general de cumplimiento del derecho, que refleja la evaluación “Trivalente”."
            />
            <EvaluationInfoDialog
                isOpen={isModalVisibleTri}
                toggle={() => setIsModalVisibleTri(false)}
                title="Evaluación trivalente"
                description="Asigna a cada indicador uno de tres valores posibles calificando con 1 la mejora, -1 el retroceso y 0 la neutralidad. Posteriormente, según la suma de los mismos resulte en un número positivo, negativo o igual a cero se escalan de forma piramidal en el siguiente orden: sub-dimensión, dimensión, tipo de indicadores y derecho. De ese modo, si, por ejemplo, el resultado de la suma de cuatro indicadores de una sub-dimensión fuera igual a 2 (1+1+1-1), se la consideraría una mejora y se le asignaría un valor positivo, igual a 1. Y así sucesivamente en los distintos niveles hasta alcanzar el estado general del derecho."
            />
        </div>
    )
}

export default Evaluations